import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { TruckProvider } from './context/TruckContext';
import { ErrorBoundary } from './components/ui/ErrorBoundary';
import { initSocket } from './services/socket';
import { initFirebase } from './services/firebase';
import App from './App';
import './index.css';

// Initialize services
initFirebase();
initSocket();

// Note: Service Worker registration is handled automatically by VitePWA

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <AuthProvider>
          <CartProvider>
            <TruckProvider>
              <App />
              <Toaster
              position="top-center"
              toastOptions={{
                duration: 3000,
                style: {
                  background: '#374151',
                  color: '#F9FAFB',
                  borderRadius: '12px',
                },
                success: {
                  iconTheme: {
                    primary: '#10B981',
                    secondary: '#F9FAFB',
                  },
                },
                error: {
                  iconTheme: {
                    primary: '#EF4444',
                    secondary: '#F9FAFB',
                  },
                },
              }}
            />
            </TruckProvider>
          </CartProvider>
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);
